import { ELocaleCode } from '@core/modules/intl/domain/enums';

export const notFoundErrorViewI18n = {
	[ELocaleCode.RU_RU]: {
		title: 'Ошибка',
		message: 'Страница не найдена',
		mainPageButtonLabel: 'На главную',
	},
	[ELocaleCode.EN_US]: {
		title: 'Error',
		message: 'Page not found',
		mainPageButtonLabel: 'Go Home',
	},
};
